<template>
    <v-row no-gutters>
        <v-col md="6" class="text-left" style="position:relative">
            <v-row no-gutters>
                <v-col cols="12">
                    <img :src="part.image" class="partImg" @error="loadPlaceholder" />
                </v-col>
                <v-col cols="12">
                    <span class="partSpan">
                        {{ part.names }}<br />
                        {{$t("livelaps_id")}}: {{ part.userId }}
                    </span>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { VCol, VRow } from 'vuetify/lib';
import GeneralService from "@/services/GeneralService";

export default {
  components:{ VCol, VRow },
  props: {
    part: Object
  },
  data() {
    return {
        errorImage: require("@/assets/images/partPlaceholder.jpg")
    }
  },
  methods: {
    loadImage(url) {
        const urlImage = GeneralService.cleanImage(url, this.$store.getters.env.get('VUE_APP_IMAGE_PLACEHOLDER'));
        return urlImage;
    },
    loadPlaceholder(e) {
        e.target.src = this.errorImage;
    }
  }
}
</script>

<style>
@media (min-width: 350px) and (max-width: 450px) {
    .partSpan {
        display: contents;
    }
    .emergencyContact .v-card__text .col-md-6.text-right, .membership .v-card__text .col-md-6.text-right,
    .waivers .v-card__text .col-md-6.text-right, .vehicles .v-card__text .col-md-6.text-right,
    .transponder .v-card__text .col-md-6.text-right, .sponsors .v-card__text .col-md-6.text-right, 
    .social .v-card__text .col-md-6.text-right {
        top: 0;
        position: absolute;
        margin: 16px 0;
    }
    .emergencyContact .v-card__text .col-md-6.text-right > button, .membership .v-card__text .col-md-6.text-right > button,
    .waivers .v-card__text .col-md-6.text-right > button, .vehicles .v-card__text .col-md-6.text-right > button,
    .transponder .v-card__text .col-md-6.text-right > button, .sponsors .v-card__text .col-md-6.text-right > button, 
    .social .v-card__text .col-md-6.text-right > button {
        margin-right: 32px;
    }
}
@media (max-width: 349px) {
    .emergencyContact .v-card__text > .row, .membership .v-card__text > .row,
    .waivers .v-card__text > .row, .vehicles .v-card__text > .row, .transponder .v-card__text > .row, 
    .sponsors .v-card__text > .row, .social .v-card__text > .row {
        display: block;
    }
    .emergencyContact .v-card__text > .row > .col-md-6, .membership .v-card__text > .row > .col-md-6,
    .waivers .v-card__text > .row > .col-md-6, .vehicles .v-card__text > .row > .col-md-6,
    .transponder .v-card__text > .row > .col-md-6, .sponsors .v-card__text > .row > .col-md-6, 
    .social .v-card__text > .row > .col-md-6 {
        width: 100%;
        margin-bottom: 1rem;
    }
    /*.alertUnpaid {
        max-height: 110px;
    }*/
    .alertUnpaid p {
        font-size: 12px !important;
    }
    .alertUnpaid a {
        font-size: 15px !important;
    }
}
</style>

<style scoped>
.headTable{
    background: #ccc;
}
.partImg{
    width: 40px;
    border-radius: 50%;
    height: 40px;
}
.partSpan{
    color: #000;
    position: absolute;
    top: 10px;
    left: 60px;
}
</style>
